export default __webpack_public_path__ + "static/media/logo.fa794e8b.png";